export interface NfzBranchDto {
  code: string;
  name: string;
}

export class NfzBranchLookup {
  public static readonly branches: NfzBranchDto[] = [
    { code: '01', name: 'Dolnoslaski Oddzial Wojewódzki NFZ' },
    { code: '02', name: 'Kujawsko-Pomorski Oddzial Wojewódzki NFZ' },
    { code: '03', name: 'Lubelski Oddzial Wojewódzki NFZ' },
    { code: '04', name: 'Lubuski Oddzial Wojewódzki NFZ' },
    { code: '05', name: 'Lódzki Oddzial Wojewódzki NFZ' },
    { code: '06', name: 'Malopolski Oddzial Wojewódzki NFZ' },
    { code: '07', name: 'Mazowiecki Oddzial Wojewódzki NFZ' },
    { code: '08', name: 'Opolski Oddzial Wojewódzki NFZ' },
    { code: '09', name: 'Podkarpacki Oddzial Wojewódzki NFZ' },
    { code: '10', name: 'Podlaski Oddzial Wojewódzki NFZ' },
    { code: '11', name: 'Pomorski Oddzial Wojewódzki NFZ' },
    { code: '12', name: 'Slaski Oddzial Wojewódzki NFZ' },
    { code: '13', name: 'Swietokrzyski Oddzial Wojewódzki NFZ' },
    { code: '14', name: 'Warminsko-Mazurski Oddzial Wojewódzki NFZ' },
    { code: '15', name: 'Wielkopolski Oddzial Wojewódzki NFZ' },
    { code: '16', name: 'Zachodniopomorski Oddzial Wojewódzki NFZ' },
  ];
}
